import { useState } from 'react';
import { useAsyncEffect } from '@design-stack-vista/utility-react';
import { getBookendHeaderData } from 'src/services/bookend';
import { BookendHeaderDataType } from 'src/types/bookend';
import { currentCulture } from 'src/utils/cultureUtil';

export const useBookendHeaderData = () => {
  const [headerData, setHeaderData] = useState<BookendHeaderDataType>();

  useAsyncEffect(() => {
    async function bookendHeaderData() {
      if (currentCulture) {
        const bookendsHeader = await getBookendHeaderData(currentCulture.toLocaleLowerCase());
        if (bookendsHeader) {
          setHeaderData(bookendsHeader);
        }
      }
    }
    bookendHeaderData();
  }, [currentCulture]);

  return headerData;
};
